module.exports = __webpack_public_path__ + "img/logo-p-800.7b38721c.png";